module.exports = __webpack_public_path__ + "img/modules/ui-header/img/aa.80f29d2b7550eeed084e636fe88aeeea.png";